"use client";

import { InfoGroup } from "#/components/InfoGroup/InfoGroup";
import { type RFQResponseState } from "#/services/kyan/kyan.types";

import { usePortfolioImpactAndGreeksController } from "./PortfolioImpactAndGreeks.controller";

export interface PortfolioImpactAndGreeksProps {
  response: RFQResponseState;
}

export const PortfolioImpactAndGreeks: React.FC<
  PortfolioImpactAndGreeksProps
> = ({ response }) => {
  const { marginData, greeksData, isLoading } =
    usePortfolioImpactAndGreeksController(response);

  return (
    <div className="mt-2 w-full">
      <InfoGroup
        variant="normal"
        rows={marginData}
        isLoading={isLoading}
        title="Portfolio Impact"
      />
      <InfoGroup
        isGreek
        variant="normal"
        rows={greeksData}
        isLoading={isLoading}
        title="Portfolio Greeks"
      />
    </div>
  );
};
